import tipoFormularioService from '../services/tipoFormularioService';

/** Remito de compra. Convención maestro: 0 = sí descuenta, 1 = no descuenta. */
export const TIPO_REMITO_COMPRA = '16' as const;

const DESCUENTA_SI = 0;

function interpretaDescuenta(descuentaStock: number | null | undefined): boolean {
  return descuentaStock == null || Number(descuentaStock) === DESCUENTA_SI;
}

/**
 * Lee Tipo Formulario (compra, tipo 16) sin escribir el maestro.
 * Si no se puede leer, se asume que descuenta (el backend es quien mueve stock).
 */
export async function remitoDescuentaStock(
  nroTipo: typeof TIPO_REMITO_COMPRA = TIPO_REMITO_COMPRA,
): Promise<boolean> {
  try {
    const tipo = await tipoFormularioService.getTipoFormulario(nroTipo);
    return interpretaDescuenta(tipo.descuentaStock);
  } catch {
    return true;
  }
}
